namespace Matrix.Common {
    export interface FormattedFullTextResult {
        html: string;
        text: string;
        url: string;
    }

    export class FullTextSearch extends Serenity.Widget<any> {

        private sidebarMenuULs;

        constructor(input: JQuery) {
            super(input);

            this.sidebarMenuULs = $('.nk-sidebar-main ul.nk-menu');

            var dropdown = input.closest('.dropdown');

            dropdown.on('shown.bs.dropdown', e => {
                input.focus();
                this.updateSidebarMatchFlags(Q.trimToNull(input.val()));
            });

            dropdown.on('hidden.bs.dropdown', e => {
                this.updateSidebarMatchFlags(null);
            });

            $(input).on('keydown', function (e) {
                if (e.keyCode == 27 && !e.ctrlKey && !e.altKey) {

                    var search = $('.nk-app-search:visible').first();
                    if (search.length) {
                        search.children('a').click();
                    }
                }
            });

            var menu = dropdown.find('.dropdown-menu');
            var ul = menu.children('ul');

            var showDropdown = () => {
                if (!dropdown.hasClass('show'))
                    dropdown.children('em')["dropdown"]('show');
            }

            var setMessage = (message: string) => {
                showDropdown();
                ul.html('<li style="opacity: 0.5; text-align: center;">' + message + '</li>');
            }

            new Serenity.QuickSearchInput(input, {
                onSearch: (field, text, done) => {

                    if (!text || text.length < 3) {
                        this.updateSidebarMatchFlags(null);
                        done(true);
                        setMessage('type 3 or more characters to search...');
                        return;
                    }

                    this.updateSidebarMatchFlags(text);

                    setMessage('searching...');

                    Matrix.Navigation.FullTextSearchService.Search({
                        SearchTerm: text
                    },
                        response => {
                            if (!response.Entities.length) {
                                setMessage('no results');
                                return;
                            }

                            ul.html('');

                            var mapped = response.Entities.map(this.formatResult).filter(x => x != null);
                            mapped.sort(this.compareResult.bind(this));

                            for (var fmt of mapped) {
                                ul.append(`<li><a href="${Q.attrEncode(Q.resolveUrl(fmt.url) ?? "javascript:;")}">${fmt.html}</a></li>`)
                            }
                        }, {
                            blockUI: false,
                            onCleanup: () => {
                                done(true);
                            }
                    });
                    
                }
            });

            input.attr('placeholder', 'search anything...');

            input.prev('.quick-search-icon').remove();
        }

        private compareResult(a, b: FormattedFullTextResult): number {
            return Q.turkishLocaleCompare(a.text, b.text);
        }

        private formatResult(result: Navigation.FullTextSearchResult): FormattedFullTextResult {
            if (!result)
                return null;

            var text: string;
            var html: string;
            var url: string;

            if (result.EntityType == 'Menu') {
                html = "<b>Page:</b> ";
                text = "Page: ";
                url = result.EntityId;

                var path = result.DisplayText || '?';
                html += path;
                text += path;
            }
            else if (result.EntityType == "Data.Account") {
                html = "<b>Account: </b> " + Q.htmlEncode(result.DisplayText + " (" + result.EntityId + ")");
                text = "Account: ";
                url = "~/Data/Account/#edit/" + result.EntityId;
            }
            else if (result.EntityType == "Data.Security") {
                html = "<b>Security: </b> " + Q.htmlEncode(result.DisplayText);
                text = "Security: ";
                url = "~/Data/Security/#edit/" + result.EntityId;
            }
            else
                return null;

            return {
                html: html,
                text: text,
                url: url
            }
        }

        protected updateSidebarMatchFlags(text: string) {
            this.sidebarMenuULs
                .closest('.nk-menu-content')
                .removeClass('is-match')
                .removeClass('non-match');

            var liList = this.sidebarMenuULs.find('li')
                .removeClass('non-match')
                .removeClass('is-match');

            text = Q.trimToNull(text);

            if (text == null) {
                return;
            }

            var parts = text.replace(',', ' ').split(' ').filter(x => !Q.isTrimmedEmpty(x));

            for (var i = 0; i < parts.length; i++) {
                parts[i] = Q.trimToNull(Select2.util.stripDiacritics(parts[i]).toUpperCase());
            }

            var items = liList;
            items.each(function (idx, e) {
                var x = $(e);
                var titles = x.add(x.parents('li').children('a')).toArray().map(ie =>
                    Select2.util.stripDiacritics(Q.coalesce($(ie).text(), '')).toUpperCase());
                var menuTitle = x.closest('.nk-content').children('.title');
                if (menuTitle.length)
                    titles.push(Select2.util.stripDiacritics(Q.coalesce(menuTitle.text(), '')).toUpperCase())
                for (var p of parts) {
                    if (p != null && !Q.any(titles, title => title.indexOf(p) >= 0)) {
                        x.addClass('non-match');
                        break;
                    }
                }
            });

            var matchingItems = items.not('.non-match');

            var visibles = matchingItems.parents('li').add(matchingItems);

            var nonVisibles = liList.not(visibles);
            nonVisibles.addClass('non-match');
            visibles.addClass('is-match');

            visibles.closest('.nk-menu-content')
                .addClass('is-match');

            this.sidebarMenuULs.closest('.nk-menu-content')
                .not('.is-match')
                .addClass('non-match');
        }
    }
}